import { gql } from '@apollo/client'

export const DELETE_PATTERISTO = gql`
  mutation deletePatteristo($id: String!) {
    deletePatteristo(id: $id) {
      id
    }
  }
`
